import { render, staticRenderFns } from "./BAdetail.vue?vue&type=template&id=b9e75ea0&scoped=true"
import script from "./BAdetail.vue?vue&type=script&lang=js"
export * from "./BAdetail.vue?vue&type=script&lang=js"
import style0 from "./BAdetail.vue?vue&type=style&index=0&id=b9e75ea0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e75ea0",
  null
  
)

export default component.exports